import { Department, DepartmentGroupDepartment, DepartmentResource } from './Department'

export const transformToDepartment = (department: DepartmentResource): Department => ({
    id: department.id,
    name: department.attributes.name,
})

export const transformDepartmentToDepartmentGroupDepartment = (department: Department): DepartmentGroupDepartment => ({
    id: department.id,
    name: department.name,
})
